var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThinkLp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10069_43620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6069 19.029C37.2565 16.2846 40.9491 14.5485 45.0184 14.5485C50.4444 14.5485 55.1466 17.5773 57.6707 22.0566C59.8488 21.079 62.2768 20.5422 64.8457 20.5422C74.6268 20.5422 82.527 28.5243 82.527 38.3682C82.527 48.212 74.5819 56.1955 64.8188 56.1955C63.6532 56.1941 62.4906 56.0778 61.3479 55.8483C59.139 59.792 54.9122 62.4723 50.0524 62.4723C48.0331 62.4723 46.1087 61.9983 44.4046 61.1911C42.165 66.4596 36.9273 70.1829 30.8362 70.1829C24.494 70.1829 19.0679 66.1764 16.9987 60.5287C16.0746 60.7185 15.1336 60.8138 14.1902 60.8131C6.62057 60.8016 0.500037 54.6196 0.500037 46.9513C0.494439 44.5289 1.12365 42.1474 2.32498 40.044C3.52631 37.9405 5.25783 36.1886 7.34704 34.9626C6.49501 33.0382 6.02223 30.8921 6.02223 28.6204C5.99019 19.881 13.1524 12.7483 21.9225 12.7483C24.3778 12.7445 26.8006 13.3093 29.0011 14.3985C31.2015 15.4878 33.1198 17.0718 34.6056 19.0264",
    fill: "#00A1E0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10069_43620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    fill: "white",
    transform: "translate(0.5 0.461182)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThinkLp);
export default __webpack_public_path__ + "static/media/thinkLp.fc251afcdaf818565e5929dfb19ab59d.svg";
export { ForwardRef as ReactComponent };